export const countryOptions = ["Kosovo", "Albania"];

export const cityOptionsByCountry = {
  Kosovo: [
    "Prishtina",
    "Prizren",
    "Peja",
    "Gjakova",
    "Gjilan",
    "Ferizaj",
    "Mitrovica",
    "Podujeva",
    "Vushtrri",
    "Suhareka",
    "Rahovec",
    "Malisheva",
    "Drenas",
    "Lipjan",
    "Fushe Kosove",
    "Obiliq",
    "Istog",
    "Decan",
    "Kline",
    "Skenderaj",
  ],
  Albania: [
    "Tirana",
    "Durres",
    "Vlore",
    "Shkoder",
    "Fier",
    "Elbasan",
    "Korce",
    "Berat",
    "Lushnje",
    "Pogradec",
    "Kukes",
    "Lezhe",
    "Gjirokaster",
    "Sarande",
    "Kamez",
    "Kavaje",
    "Patos",
    "Lac",
    "Peshkopi",
    "Kucove",
  ],
};
